import type { LiveActivitySnapshot } from '@shared/liveActivity';

export async function syncLiveActivity(_snapshot: LiveActivitySnapshot | null): Promise<void> {}
